export default ({ request }) => ({
  // 供应商拜访记录相关接口
  scmInfoVisitListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisit/list',
      method: 'post',
      data,
    })
  },
  scmInfoVisitDetailApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisit/detail',
      method: 'post',
      data,
    })
  },
  //刪除
  scmInfoVisitDelApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisit/del',
      method: 'post',
      data,
    })
  },
  scmInfoVisitSaveApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisit/save',
      method: 'post',
      data,
    })
  },
  scmInfoVisitListTimeLineApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisit/listTimeLine',
      method: 'post',
      data,
    })
  },
  // 我的供应商拜访记录相关接口
  myVisitListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisit/myList',
      method: 'post',
      data,
    })
  },
  // 报销申请
  scmInfoVisitApplyApi(data) {
    return request({
      url: '/oa/scm/info/visit/visitApply',
      method: 'post',
      data,
    })
  },
  scmInfoVisitListDataAnalysisApi(data) {
    return request({
      url: '/digitalCenter/scmInfoVisit/listDataAnalysis',
      method: 'post',
      data,
    })
  },
})
